import { useQuery } from 'react-query';

import { getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration } from 'src/client/spendesk-api';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

export const useAnalyticalSplitSettingsQuery = (enabled: boolean = true) => {
  const companyId = useCompanyId();

  const { data, isLoading } = useQuery({
    queryKey: ['analytical-split-settings', companyId],
    enabled,
    queryFn: async () => {
      const res =
        await getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration(
          {
            path: {
              companyId,
            },
          },
        );

      if (res.statusCode === 200) {
        return res.body;
      }

      return [];
    },
  });

  return {
    isLoading,
    settings: data,
  };
};
